import { IRowNode } from 'ag-grid-community';

export interface GridRowSelect {
  model: any;
  node: IRowNode;
  selected: boolean;
  rowIndex: number;
}
